import React, { ReactElement, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Button, TextArea, TextInput } from '@videoblocks/storywind';

import { FolderFeedbackContent } from '../types';

export interface FolderFeedbackFormProps {
  onSubmit: (content: FolderFeedbackContent) => void;
  isSubmitting: boolean;
}

export default function FolderFeedbackForm({
  onSubmit,
  isSubmitting,
}: FolderFeedbackFormProps): ReactElement {
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [emailAddress, setEmailAddress] = useState<string>('');
  const [comments, setComments] = useState<string>('');

  const labelClassNames = 'mb-1.5';
  const inputClassNames = 'mb-4';

  return (
    <>
      <h3 className="text-2xl text-center">Submit Feedback</h3>
      <form
        className="bin-feedback-form max-w-lg flex flex-col maker-md:px-0 px-2 mx-auto mt-5 mb-14"
        onSubmit={(e) => {
          e.preventDefault();
          if (isSubmitting) {
            return;
          }

          onSubmit({ firstName, lastName, emailAddress, comments });
        }}
      >
        <TextInput
          type="text"
          className={inputClassNames}
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />

        <TextInput
          type="text"
          className={inputClassNames}
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />

        <TextInput
          type="email"
          className={inputClassNames}
          placeholder="Email Address"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          required
        />

        <label
          className={twMerge('text-base font-semibold block', labelClassNames)}
          htmlFor="feedback-comments"
        >
          Comments
        </label>
        <TextArea
          id="feedback-comments"
          placeholder="Comments"
          cols={2}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          required
        />

        <Button className="w-max mt-4" type="submit" disabled={isSubmitting}>
          Submit Feedback
        </Button>
      </form>
    </>
  );
}
